<template>
  <div>
    <!-- table -->
    <v-simple-table>
      <template v-slot:default>
        <thead>
        <div v-if="lengthOfisCheckedList > 0"
             class="form-item d-flex align-center px-5 h-60px batch">
          <h5 class="col-checkbox">
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </h5>
          <h5 class="mr-22px">{{ lengthOfisCheckedList }} 項已選取</h5>
          <div>
            <button class="btn btn-danger mr-10px" @click="multiDelete">
              <v-icon color="white" class="mr-2">delete</v-icon>
              <span>刪除</span>
            </button>
          </div>
          <div>
            <button class="btn mr-10px" @click="multiChangeStatus(true)">設為顯示</button>
          </div>
          <div>
            <button class="btn" @click="multiChangeStatus(false)">設為隱藏</button>
          </div>
        </div>
        <tr>
          <th>
            <v-checkbox
              v-model="checkAllStatus"
              :indeterminate="indeterminate"
              @click="changeAllCheckbox"
            ></v-checkbox>
          </th>
          <th class="text-left col-banner-title">標題</th>
          <th class="text-left col-banner-title">副標題</th>
          <th class="text-left col-banner-title">排序</th>
          <th class="text-left">顯示/隱藏</th>
          <th class="text-left">編輯</th>
          <th class="text-left">刪除</th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="item in slidebannerList"
          :key="item.id"
        >
          <td>
            <v-checkbox v-model="item.isChecked"></v-checkbox>
          </td>
          <td>{{ item.title }}</td>
          <td>{{ item.description }}</td>
          <td>{{ item.order }}</td>
          <td>
            <FormSwitch v-model="item.status"
                        @changeStatus="toggleStatus(item.id)"></FormSwitch>
          </td>
          <td>
            <button class="btn square" @click="toSlidebannerEdit(item.id)">
              <v-icon>edit</v-icon>
            </button>
          </td>
          <td>
            <deleteDialog @confirm-delete="deleteItem(item.id)"></deleteDialog>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
    <!-- table footer -->
    <Pagination @handleNextPreEvent="getSlidebannerList" model="slidebanner"></Pagination>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FormSwitch from '@/components/FormSwitch.vue';
import Pagination from '@/components/Pagination.vue';
import deleteDialog from '@/components/C-1b__CategoriesList_Dialog-ConfirmDelete.vue';

export default {
  components: {
    FormSwitch,
    Pagination,
    deleteDialog,
  },
  data: () => ({
    // filter
    checkAllStatus: false, // left top checkbox status
    // selectedItems
    selectedItems: [],
  }),
  computed: {
    ...mapState('slidebanner', ['slidebannerList']),
    lengthOfisCheckedList() {
      return this.slidebannerList.filter((item) => item.isChecked)
        .length;
    },
    indeterminate() {
      if (
        this.lengthOfisCheckedList === 0 ||
        this.lengthOfisCheckedList === this.slidebannerList.length
      ) {
        return false;
      }
      return true;
    },
    isCheckedListIds() {
      return this.slidebannerList.filter((item) => item.isChecked).map((item) => item.id);
    },
  },
  watch: {
    lengthOfisCheckedList(newValue) {
      if (newValue < this.slidebannerList.length) {
        this.checkAllStatus = false;
      }
      if (newValue === this.slidebannerList.length) {
        this.checkAllStatus = true;
      }
    },
  },
  methods: {
    ...mapActions('slidebanner', {
      getSlidebannerList: 'find',
      destroySlidebanner: 'destroy',
      clear: 'clear',
      changeStatus: 'changeStatus',
    }),
    toSlidebannerEdit(id) {
      this.$router.push({
        name: 'BannerEdit',
        params: { id },
      });
    },
    changeAllCheckbox() {
      if (this.checkAllStatus) {
        this.slidebannerList.forEach(
          (item) => (item.isChecked = true),
        );
      } else {
        this.slidebannerList.forEach(
          (item) => (item.isChecked = false),
        );
      }
    },
    async deleteItem(id) {
      this.clear();
      await this.destroySlidebanner(id).then(() => {
        this.getSlidebannerList();
      });
    },
    async multiDelete() {
      await this.isCheckedListIds.forEach((id) => {
        this.destroySlidebanner(id).then(() => {});
      });
      this.getSlidebannerList();
    },
    async multiChangeStatus(status) {
      await this.isCheckedListIds.forEach((id) => {
        this.changeStatus({
          id, status,
        }).then(() => {});
      });
      this.getSlidebannerList();
    },
    toggleStatus(id) {
      this.changeStatus({ id }).then(() => {
        this.getSlidebannerList();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-banner-title {
    width: 390px;
    margin-right: 50px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .col-tab {
    width: 130px;
    margin-right: 10px;
  }
  .col-show {
    margin: 0 20px;
  }
}
</style>
